// extracted by css-extract-rspack-plugin
export default {"adPlaceholder":"_4fdaf07","adContainer":"_48e645e3"};